import { supabase } from '../config/supabase';

export interface ReminderEmail {
  id: string;
  org_id: number;
  to: string;
  from: string;
  subject: string;
  body: string;
  created_at: string;
}

export const emailReminderService = {
  /**
   * Get all reminder emails for the current user's organization
   * Only owners and admins can access this
   */
  async getReminderEmails(): Promise<ReminderEmail[]> {
    try {
      // Get current user and verify permissions
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      
      if (authError || !user) {
        throw new Error('User not authenticated');
      }

      // Get user profile to check role and org_id
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('org_id, role')
        .eq('id', user.id)
        .single();

      if (profileError || !profile) {
        throw new Error('Could not fetch user profile');
      }

      // Verify user has appropriate role
      if (profile.role !== 'owner' && profile.role !== 'admin') {
        throw new Error('Access denied: Only owners and admins can view reminder emails');
      }

      // Fetch reminder emails for the user's organization, ordered by most recent first
      const { data, error } = await supabase
        .from('reminder_emails')
        .select('*')
        .eq('org_id', profile.org_id)
        .order('created_at', { ascending: false });

      if (error) {
        throw error;
      }

      return data || [];

    } catch (error: any) {
      throw error;
    }
  }
};

export default emailReminderService;

